<template>
    <div v-if="show" class="login-pop relative">

        <div class="login-pop-title">

            <div
                class="pointer"
                :class="[index === 0 ? 'fl' : 'fr',selected === index ? 'active-type' : '']"
                v-for="(item,index) in loginTypes"
                :key="'login-type-'+index"
                @click="selected = index"
            >{{ item.name }}</div>

        </div>

        <div v-if="selected === 0">

            <div class="login-input login-margin cf">

                <img class="fl login-input-icon" src="./images/login_icon_user@2x.png" />

                <input class="fl" type="text" v-model="mobile" placeholder="请输入手机号码" />

            </div>

            <div class="reg-code login-margin cf">

                <img class="fl login-input-icon" src="./images/register_icon_verify@2x.png" />

                <input class="fl" type="number" v-model="code" placeholder="请输入验证码" />

                <div
                    class="fr code-btn button-active pointer"
                    :style="{ color: disabled ? '#d10916' : '#999999' }"
                    @click="getCode"
                >{{ codeText }}</div>

            </div>

        </div>

        <div v-else>

            <div class="login-input login-margin cf">

                <img class="fl login-input-icon" src="./images/login_icon_user@2x.png" />

                <input class="fl" type="text" v-model="mobile" placeholder="请输入手机号码" />

            </div>

            <div class="login-input cf">

                <img class="fl login-input-icon" src="./images/login_icon_code@2x.png" />

                <input class="fl" :type="input_type ? 'password' : 'text'" v-model="password" placeholder="请输入登录密码" />

                <div class="eye fr" @click="input_type = !input_type">

                    <img v-if="input_type" src="./images/sign_ico_eye_closed@2x.png" />

                    <img v-else src="./images/sign_ico_eye_opened@2x.png" />

                </div>

            </div>

        </div>

        <div class="login-btn button button-active" @click="loginType">登录</div>

        <div class="login-text cf">

            <div class="fl button-active pointer" @click="openForget">忘记密码</div>

            <div class="fr button-active pointer" @click="openReg">快速注册</div>

        </div>

        <div class="three-login absolute cf">

            <div class="three-login-label fl">三方登录：</div>

            <img
                class="fl button-active three-login-icon"
                v-for="(item,index) in threeLoginList"
                :key="'three-login-icon-'+index"
                :src="item.icon"
                @click="threeLogin(item)"
            />

        </div>

        <img
            class="close-pop absolute button-active"
            src="./images/sign_ico_closed@2x.png"
            @click.stop="close"
        />

    </div>
</template>

<script>
import mixin from "./mixin/mixin";
export default {
    name: "layout-login",
    mixins: [mixin],
    props: {
        show: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style scoped src="./style.css"></style>
